import React from 'react';
import { useForm } from "react-hook-form";
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { registerUser } from '../../store/auth'
import { useTranslation } from 'react-i18next';
import { getImagePath } from '../../utils/imagePath';
import { useAuth } from '../../contexts/AuthContext';


const Register = () => {
    const {t} = useTranslation();
    const { register, handleSubmit, watch, formState: { errors } } = useForm();

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { login } = useAuth();
    
    const onSubmit = async (data) => {
        try {
            delete data.others            
            const response = await dispatch(registerUser(data)).unwrap();
            
            console.log('[REGISTER] Response received:', response);
            
            // Check if registration was successful and includes token (automatic login)
            if (response && response.success && response.token) {
                console.log('[REGISTER] Saving token and user data');
                // Save token and session_token for compatibility
                localStorage.setItem('token', response.token);
                localStorage.setItem('session_token', response.token);
                
                if (response.user) {
                    localStorage.setItem('userData', JSON.stringify(response.user));
                }
                
                // Update AuthContext
                console.log('[REGISTER] Calling login() with token');
                login(response.token);
                
                // Wait a bit longer to ensure state is fully updated, then navigate to home
                setTimeout(() => {
                    console.log('[REGISTER] Navigating to home');
                    const basePath = process.env.REACT_APP_BASE_PATH || '/';
                    const homePath = basePath === '/' ? '/home' : `${basePath}/home`;
                    navigate(homePath, { replace: true });
                }, 500);
            } else {
                console.log('[REGISTER] No token in response, redirecting to login');
                // If no token, redirect to login page (old behavior)
                navigate('/login');
            }
        } catch (error) {
            console.error('[REGISTER] Register failed:', error);
            // On error, stay on register page (error already shown by toast)
        }
    };
    const password = watch("wachtwoord", "");
    const isChecked = watch("others", false);

    return (
        <main className="main-wrapper main-wrapper3">

            {/* register-area start  */}
            <section className="register-area">
                <div className="container">
                    <div className="register-item">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="register-item-inner">
                                <h2>{t('Open an account')}</h2>
                                <img src={getImagePath('/images/register-01.png')} alt="" />
                            </div>
                            <div className="register-item-inner2">
                                <div className="register-item-inner3">
                                    <div className='validation-box'>
                                        <div className="register-item-inner4 m-0">
                                            <input name="" type='email' placeholder={t('Email')} {...register('email', { required: true })} />
                                            <img src={getImagePath('/images/register-02.png')} alt="" />
                                        </div>
                                        {errors.email && <div className='error-text m-2'>{t('This field is required')}</div>}
                                    </div>
                                </div>
                                <div className="register-item-inner3">
                                    <div className='validation-box'>
                                        <div className="register-item-inner4 m-0">
                                            <input type="text" name="" placeholder={t('Username')} {...register('username', { required: true })} />
                                            <img src={getImagePath('/images/register-02.png')} alt="" />
                                        </div>
                                        {errors.username && <div className='error-text m-2'>{t('This field is required')}</div>}
                                    </div>
                                </div>
                                <div className="register-item-inner3">
                                    <div className='validation-box'>

                                        <div className="register-item-inner4 m-0">
                                            <input type="password" name="" placeholder={t('Password')} {...register('wachtwoord', { required: true })} />
                                            <img src={getImagePath('/images/register-02.png')} alt="" />
                                        </div>
                                        {errors.wachtwoord && <div className='error-text m-2'>{t('This field is required')}</div>}

                                    </div>
                                </div>
                                <div className="register-item-inner3">
                                    <div className='validation-box'>

                                        <div className="register-item-inner4 m-0">
                                            <input type="password" name="" placeholder={t('Confirm password')} {...register('wachtwoord_nogmaals', {
                                                    required: "This field is required",
                                                    validate: value => value === password || "Passwords do not match"
                                                })} />
                                            <img src={getImagePath('/images/register-02.png')} alt="" />
                                        </div>
                                        {errors.wachtwoord_nogmaals && <div className='error-text m-2'>{t(errors.wachtwoord_nogmaals.message)}</div>}

                                    </div>
                                </div>
                                <div className="register-item-inner3">
                                    <div className='validation-box'>
                                        <div className="register-item-inner4 m-0">
                                            <input type="password" name="" placeholder={t('Refferal')} {...register('refferal')} />
                                            <img src={getImagePath('/images/register-02.png')} alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="register-item-inner5 validation-box">
                                <input type="checkbox" id="test" {...register("others", { required: true })} />
                                <label htmlFor="test">
                                    <span>
                                        {isChecked && <img src={getImagePath('/images/register-03.png')} alt="Checked" />} {/* Show image if checked */}
                                    </span>
                                    {t('I agree with the Terms of Service and Privacy Policy')}
                                </label>
                                {errors.others && <span className='error-text m-3'>{t('This field is required')}</span>}
                            </div>
                            <div className="register-item-inner6">
                                <button type="submit">{t('Submit')}</button>
                            </div>
                            <div className="register-item-inner6 mt-3">
                                <button onClick={()=>{navigate('/login')}} className='register-button'>
                                    <span>{t('Login')}</span>
                                <img src={getImagePath('/images/banner-03.png')} alt=""/>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
            {/* register-area end */}

        </main>
    );
};

export default Register;